<template>
  <div>
    <ul>
      <li
        v-for='consumption in popupData.useConsumptions'
        :key="`use-${consumption.use.slug}`">
        {{ consumption.use.label }} <em v-if='consumption.estimation'>(estimé)</em>: {{ consumption.consumption|formatIntNumber }} kWh ({{ consumption.percentage|displayPercentage }})
      </li>
      <li>Total: {{ popupData.totalConsumption|formatIntNumber }} kWh</li>
    </ul>
  </div>
</template>

<script>
import ValuesDisplayMixin from '../mixins/ValuesDisplayMixin'

export default {
  name: 'BuildingStockUsesPopup',
  mixins: [ValuesDisplayMixin],
  data () {
    return {}
  },
  props: {
    popupData: {
      type: Object,
      required: true,
      default: function () {
        return {
          totalConsumption: 0,
          useConsumptions: []
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/BuildingStockUsesPopup.vue